import type { QueryClient } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { removeAdvisorFromCache } from "web_myplann/Api/Advisor/removeAdvisorFromCache";
import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";
import {
	type AgentAssignedListItemResponseDTO,
	UserAgentStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const removeConnectedAdvisorAndInvalidate = (
	queryClient: QueryClient,
	{ id, uid }: AgentAssignedListItemResponseDTO,
) => {
	queryClient.setQueryData<AssignedAgentsQueryData>(
		AdvisorKeys.assignedAgents(UserAgentStatusEnum.Connected),
		(cached) => removeAdvisorFromCache(cached, id),
	);
	queryClient.removeQueries({ queryKey: AdvisorKeys.detail(uid) });
	void queryClient.invalidateQueries({ queryKey: AdvisorKeys.all });
};
